import {FC} from 'react';
import {useSelector} from '@xstate/react';
import {useAudioPanelToggle} from '../../hooks/useAudioPanelToggle';
import {ControlButton} from '../controlButton';
import AudioIcon from './audioIcon.svg';
import {useAudioTrackService} from '../../hooks/useTrackContext';
import {generateSelector} from '../../utils/generateSelector';

export const AudioButton: FC = () => {
  const service = useAudioTrackService();
  const audioTracks = useSelector(service, ({context}) => context.tracks);
  const isOpen = useSelector(service, generateSelector('open'));
  const onClick = useAudioPanelToggle();

  // Only render if there are multiple audio tracks to choose from
  if (audioTracks.length <= 1) return null;

  return (
    <ControlButton
      tooltipLabel="Audio Tracks"
      ariaLabel="Audio Tracks Panel"
      ariaPressed={isOpen}
      onClick={onClick}
    >
      <AudioIcon />
    </ControlButton>
  );
};
